

















































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Nav from './../Business/pages/components/Navs.vue'
import Tabs from '@/components/Tabs/index.vue'
import {
  getAmountAccountType,
  accountRecharge,
  createPayQRCode,
  findRechargeLogs,
  currentUserBalance
} from '@/api/transaction'
import { checkAlipayAccount, pageSign, signQuery, pagePay, getAccountBalance } from '@/api/alipaysafe'

interface bankListType {
  account: string; // 对应账户
  bankId: string; // 银行ID，可能会出现重复，因为同一个银行有不同的渠道。唯一的用code分别。
  bankTypeId: number; // 账户类型ID
  bankTypeName: string; // 账户类型名字
  code: string; // 银行唯一标识
  enable: boolean; // 是否启用
  id: number; // 账户渠道ID（对应saasPayService）
  name: string; // 账户类型名称
  supportCurrency: string[]; // 支持币种
  thePrivate: boolean; // 是否对私
  title: string; // 标题
}

@Component({
  components: {
    Nav,
    Tabs
  }
})
export default class Recharge extends Vue {
  // 用户的币种信息
  userList: any[] = []
  isEarnest = false // 判断是否是保证金充值

  loading = false;

  TabList = [
    {
      name: '网银',
      id: 1
    },
    {
      name: '第三方支付',
      id: 2
    },
    {
      name: '全球货仓代收代付(充值)',
      id: 3
    }
  ];

  // 用户跳转到当前页面的时候 选择的充值的货币
  private currencyType = '';

  // 提交参数
  params = {
    money: '', // 充值数量
    type: '' // 充值渠道
  };

  // 支付充值弹框提示标题
  dialogTitle = '支付码';

  // 支付充值提示标题
  title = '';

  // 支付弹框
  dialogVisible = false;

  // 二维码支付信息
  QRcode = '';

  // 银行
  private bankList: Array<bankListType> = [];

  // 第三方支付平台
  private TPC: Array<bankListType> = [];

  // 线下支付
  private offlinePayment: Array<bankListType> = [];

  active: string | number = 2;

  // 充值回调次数
  callBackNum = 0;

  // 银行卡三要素数据 弹框
  bankVisible = false;

  // 银行卡三要素数据
  bankCard: {
    bankName?: string;
    payeeName?: string;
    payeeCardNo?: string | number;
  } = {};

  // 支付宝 安全发 需要用到的 记账本id
  private accountBookId = ''

  // 用来记录 轮询 定时器
  private timeOut = 0;
  private windowPage: Window | null = null;

  get navBarList () {
    return [
      {
        id: 0,
        name: '全球货仓代收(充值)记录',
        path: `/cash/withdrawRecord?currency=${this.currencyType}&typeId=0`
      },
      {
        id: 1,
        name: '商户中心',
        path: '/business/info'
      }
    ]
  }

  // 保留两位小数
  toDecimal2 (x: number | string): string {
    let num: number

    if (typeof x === 'string') {
      num = parseFloat(x)
    } else {
      num = x
    }

    if (isNaN(num)) {
      return '0.00' // 返回默认值，避免 false
    }

    num = Math.round(num * 100) / 100

    const s = num.toFixed(2) // 使用 toFixed 确保两位小数
    return s
  }

  get list (): Array<bankListType> {
    if (this.active === 1) {
      return this.bankList
    } else if (this.active === 2) {
      return this.TPC
    }
    // 先隐藏 网商银行的充值入口  2021/08/09
    // return this.offlinePayment
    return []
  }

  get moneyValidator () {
    if (
      window.location.origin === 'https://gtpw-ui-ts-stag.zowoyoo.com' ||
      process.env.NODE_ENV === 'development'
    ) {
      return 0.1
    }
    return 10
  }

  // 充值金额校验
  validator (rule, value, callback): void {
    if (/[^\d|.]/.test(value)) {
      callback(new Error('仅支持整数和两位小数'))
    } else if (Number(value) < this.moneyValidator) {
      callback(new Error(`金额必须大于 ${this.moneyValidator}`))
    } else if (value.replace(/\d+./, '').length > 2) {
      callback(new Error('仅支持两位小数点'))
    } else {
      callback()
    }
  }

  // 获取充值信息 - 银行 第三方  线下
  getAmountAccountType (): void {
    getAmountAccountType().then((res) => {
      res.forEach((item: bankListType) => {
        if (
          item.enable &&
          item.supportCurrency.indexOf(this.currencyType) > -1
        ) {
          // 网银
          if (item.bankTypeId === 0) {
            this.bankList.push(item)
          } else if (item.bankTypeId === 1) {
            // 第三方
            this.TPC.push(item)
            console.log(this.TPC)
          } else if (item.bankTypeId === 2 && item.bankId !== 'UnderLine') {
            // 线下充值不支持
            // 线下  网商银行支持
            this.offlinePayment.push(item)
          }
        }
      })
    })
  }

  // 选中充值渠道
  inputRadioGroup (value: string) {
    // 判断是 支付宝安全发 渠道 要检查是否已经绑定了支付宝账户
    if (value === 'AlipaySafe') {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      checkAlipayAccount({
        currencyCode: this.currencyType
      }).then(res => {
        console.log(res)
        loading.close()
        if (res.success) {
          this.accountBookId = res.data
        } else {
          this.$confirm('是否前往签约？', res.msg, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handlePageSign()
          }).catch(() => {
            this.params.type = ''
          })
        }
      })
    }
  }

  // 轮询 支付宝安全发 记账本 是否有足够金额
  handleGetAccountBalance () {
    return new Promise((resolve) => {
      const { type, money } = this.params
      getAccountBalance({
        accountBookId: this.accountBookId,
        code: type,
        currencyCode: this.currencyType,
        money
      }).then(res => {
        if (res.success) {
          if (this.windowPage) this.windowPage.close()
          resolve(res)
        } else {
          if (this.windowPage && this.windowPage.closed) {
            this.loading = false
            return
          }
          setTimeout(() => {
            this.handleGetAccountBalance().then(res => {
              resolve(res)
            })
          }, 3000)
        }
      })
    })
  }

  // 检查 支付宝安全发 记账本 是否有足够金额，如果没有就要唤起充值
  handlePagePay (): Promise<{
    code: string
    data?: {
      codeImgUrl: string
      codeUrl: string
      fee: string
      msg: string
      orderId: string
      success: 'true' | 'false'
    },
    msg: string
    state: string
    success: boolean
  }> {
    return new Promise((resolve) => {
      pagePay({
        accountBookId: this.accountBookId, // 记账本id
        code: this.params.type, // 金额收取渠道
        currencyCode: this.currencyType, // 币种
        money: this.params.money // 金额
      }).then(res => {
        if (res.state === 'success') {
          // data 有值 就是余额不足 需要充值
          if (res.data) {
            if (res.data.codeUrl) {
              if (this.windowPage) this.windowPage.close()
              this.windowPage = window.open(res.data.codeUrl,
                '支付宝安全发',
                'height=600' +
                ',innerHeight=600' +
                ',width=500' +
                ',innerWidth=500' +
                ',top=200' +
                ',left=500' +
                ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no'
              )
            }
          }
        } else {
          this.$message.error(res.msg)
          if (this.windowPage) this.windowPage.close()
        }
        resolve(res)
      })
    })
  }

  // 获取当前用户的币种信息
  getCurrentUserBalance (): void {
    currentUserBalance()
      .then((res: any) => {
        if (res) {
          this.params.money = (res[0].minGuaranteeMoney / 100).toString()
        }
      })
  }

  // 获取支付宝授权
  handlePageSign () {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    pageSign({
      currencyCode: this.currencyType
    }).then(res => {
      console.log(res)
      loading.close()
      if (res.success) {
        this.handleSignQuery()
        this.windowPage = window.open(res.data,
          '支付宝安全发',
          'height=600' +
          ',innerHeight=600' +
          ',width=500' +
          ',innerWidth=500' +
          ',top=200' +
          ',left=500' +
          ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no')
      } else {
        this.$message.error(res.msg)
      }
    })
  }

  // 轮询支付宝授权结果
  handleSignQuery () {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    let outNum = 300000 // 5分钟 60 秒 * 5 分钟 * 1000 毫秒 = 300000
    // let outNum = 120000
    const timeNum = 5000
    this.timeOut = setInterval(() => {
      outNum -= timeNum
      if (outNum <= 0) {
        this.params.type = ''
        this.$message.error('超时')
        if (this.windowPage) this.windowPage.close()
        loading.close()
        clearInterval(this.timeOut)
        this.timeOut = 0
      } else {
        signQuery()
          .then(res => {
            console.log(res)
            if (res.success) {
              if (this.windowPage) this.windowPage.close()
              this.inputRadioGroup('AlipaySafe')
              loading.close()
              clearInterval(this.timeOut)
              this.timeOut = 0
            }
          })
      }
    }, timeNum)
  }

  // 用户点击了充值
  async clickCharge () {
    const { type, money } = this.params
    if (!type) {
      this.$message({
        type: 'error',
        message: '请选中充值通道'
      })
      return false
    }
    if (this.accountBookId && type === 'AlipaySafe') {
      this.loading = true
      console.log('来了老弟1')
      const pagePayInfo = await this.handlePagePay()
      console.log('来了老弟2')
      if (pagePayInfo.data && pagePayInfo.data.codeUrl) {
        console.log('来了老弟3')
        await this.handleGetAccountBalance()
        console.log('来了老弟4')
      }
      // await this.handleGetAccountBalance()
      console.log('来了老弟5')
      this.loading = false
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.form.validate(async (boolean, object) => {
      if (boolean) {
        this.loading = true
        let payTypeParams = {}
        if (this.isEarnest) {
          payTypeParams = { payType: '1' }
        }
        const res = await accountRecharge({
          ...payTypeParams,
          code: type,
          currencyCode: this.currencyType,
          money: Number(money)
        })
        if (res.success) {
          console.log('用户点击了充值')
          console.log(type)
          if (type === 'alipayqc') {
            // 支付宝充值
            this.dialogTitle = '支付宝-支付码'
            this.title =
              '请使用 <span data-v-5600792f="" style="color: rgb(43, 104, 178);">支付宝</span> 扫码，向 <span data-v-5600792f="" style="color: rgb(43, 104, 178);">广州自我游网络科技有限公司</span> 进行支付'
            // 获取充值二维码
            const code = await createPayQRCode({
              data: res.data.codeUrl || res.data.codeURL,
              width: 240
            })
            if (code) {
              // 将文件里转换为图片
              var reader = new FileReader()
              reader.readAsDataURL(code)
              reader.onload = (e) => {
                if (
                  e.target &&
                  e.target.result &&
                  typeof e.target.result === 'string'
                ) {
                  this.QRcode = e.target.result
                  this.loading = false
                  this.dialogVisible = true
                  this.getFindRechargeLogs(res.data.orderId)
                }
              }
            } else {
              this.$message({
                type: 'error',
                message: '充值二维码获取失败！'
              })
            }
          } else if (type === 'wechatswiftpass') {
            // 微信充值
            this.dialogTitle = '微信-支付码'
            this.title =
              '请使用 <span data-v-5600792f="" style="color: rgb(43, 104, 178);">微信</span> 扫码，向 <span data-v-5600792f="" style="color: rgb(43, 104, 178);">广州自我游网络科技有限公司</span> 进行支付'
            this.QRcode = res.data.codeImgUrl
            this.dialogVisible = true
            this.loading = false
            this.getFindRechargeLogs(res.data.orderId)
          } else if (type === 'MYBANK') {
            // 网商银行充值
            this.bankCard = res.data
            this.loading = false
            this.bankVisible = true
            this.getFindRechargeLogs(res.data.orderId)
          } else if (type === 'AlipaySafe') {
            this.loading = false
            // 支付宝充值
            this.dialogTitle = '支付宝-安全发'
            this.title = '支付查询中,请稍后...'
            this.dialogVisible = true
            this.getFindRechargeLogs(res.data.orderId)
          } else {
            const newWindow = window.open()
            if (newWindow) {
              newWindow.document.body.innerHTML =
                '<span style="font-size:20px;line-height:36px">支付跳转中......</span>'
              newWindow.location = res.data.url + res.data.paramters
            }
          }
        } else {
          this.loading = false
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      } else {
        this.$message({
          type: 'error',
          message: object.money[0].message
        })
      }
    })
  }

  handleClose () {
    this.$confirm('确认关闭？').then(() => {
      this.callBackNum = 0
      this.bankVisible = false
      this.dialogVisible = false
      clearInterval(this.timeOut)
    })
  }

  // 充值轮训查询
  getFindRechargeLogs (orderId: string) {
    const { type } = this.params
    const num = 30
    this.timeOut = setInterval(() => {
      findRechargeLogs({
        bankCode: type,
        orderId,
        typeId: 0
      }).then((res) => {
        console.log('res')
        console.log(res)
        if (this.callBackNum >= num) {
          clearInterval(this.timeOut)
          this.$message({
            showClose: true,
            message:
              '暂时还没有查询到到账记录，根据银行不同，一般到账时间为3~120分钟，请通过历史充值记录查询。',
            type: 'error',
            duration: 0
          })
          this.timeOut = 0
          return false
        }
        if (res && res.length) {
          res.forEach((data) => {
            if (data.orderStatus === 4) {
              // 转账窗口关闭
              this.dialogVisible = false
              this.$message({
                showClose: true,
                message:
                  '已经到账，转账窗口关闭，如有疑问可以到充值记录查询或联系客服',
                type: 'success',
                duration: 0
              })
              clearInterval(this.timeOut)
              this.timeOut = 0
              let path = ''
              for (
                let i = 0, length = this.navBarList.length;
                i < length;
                i++
              ) {
                const item = this.navBarList[i]
                if (item.id === 0) {
                  path = item.path
                }
              }
              this.$router.push(path)
            } else {
              this.callBackNum += 1
            }
          })
        } else {
          this.callBackNum += 1
        }
      })
    }, 3000)
  }

  // 点击了联系客服
  serviceQq () {
    window.open(
      'http://wpa.qq.com/msgrd?v=3&uin=800008785&site=gtpw.zowoyoo.com&menu=yes'
    )
  }

  mounted (): void {
    const { currency, isEarnest = '' } = this.$route.query
    if (isEarnest) {
      this.isEarnest = true
      this.active = 3
      this.getCurrentUserBalance()
    }
    if (typeof currency === 'string') {
      this.currencyType = currency
      this.getAmountAccountType()
    } else {
      this.$message({
        type: 'error',
        message: '币种参数丢失！'
      })
    }
  }
}
